import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
    data:[],
    isLoading:null,
    status:null,
}

const token = userObj?.token

export const getAllVehicleTypes = createAsyncThunk(
    'customer/getAllVehicleTypes',
    async (_, {rejectWithValue}) => {
        
        try{
            const response = await axios.get("Settings/VehicleTypes",
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            return rejectWithValue(err.response.data.title)
        }
        
    }
)


const getAllVehicleTypesSlice = createSlice({
    name: 'getAllVehicleTypes',
    initialState,
    reducers: {},
    extraReducers:{
        [getAllVehicleTypes.pending]: (state, action) => {
            state.status='pending';
            state.isLoading=true;
        },
        [getAllVehicleTypes.fulfilled]: (state, action) => {
            state.status='success';
            state.isLoading=false;
            state.data = action.payload;
            // localStorage.setItem('user', JSON.stringify(action.payload))
        },
    
        [getAllVehicleTypes.rejected]: (state, action) => {
            state.status='failed';
            state.isLoading=false;
        }
    }
})

export default getAllVehicleTypesSlice.reducer;